var React = require('react');

function IconRetailDataAnalytics (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31.7439 23.2285C28.9431 29.8521 22.068 33.794 14.9369 32.865C7.80567 31.936 2.16996 26.3643 1.15958 19.2442C0.1492 12.1241 4.01232 5.20441 10.6035 2.32812","stroke":"#00D664","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.0082 17.0034C33.0082 12.759 31.3222 8.68849 28.321 5.68728C25.3198 2.68606 21.2492 1 17.0049 1V17.0034H33.0082Z","stroke":"#00D664","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconRetailDataAnalytics.defaultProps = {"width":"35","height":"34","viewBox":"0 0 35 34","fill":"none"};

module.exports = IconRetailDataAnalytics;

IconRetailDataAnalytics.default = IconRetailDataAnalytics;
